export default "__VITE_ASSET__aac81ee7__"